import { useState } from 'react'

import { uniqBy } from 'lodash'

import { Option } from 'modules/expenses/components/FormFieldEditModal/Options'
import {
  CustomizationField,
  mileageRateOptions,
} from 'modules/expenses/hooks/useExpensesCustomization'
import { FieldOptions } from 'modules/expenses/lib/types'

const useRateOptions = (field: CustomizationField): FieldOptions => {
  const [options, setOptions] = useState<Option[]>(() => mileageRateOptions(field))
  const valid = options.every((option) => Number(option.value))

  const normalized = uniqBy(
    options.map((option) => {
      return { label: String(option.label), value: Number(option.value) }
    }),
    'label'
  )

  return { value: options, set: setOptions, normalized, valid }
}

export default useRateOptions
